
export const CONTACTS = {
    PHONE_NUMBER: [
        "+996 999 963 969",
    ],
    ADDRESS: {
        titleKg: "Бишкек ш., Бакаева 140/1, БЦ Sky Plaza",
        titleRu: "г. Бишкек, Бакаева 140/1, БЦ Sky Plaza"
    }
}


export const SOCIAL_LINKS = [
    {
        iconWhite: "/img/instagram.png",
        iconDark: "/img/instagram.png",
        link: "https://www.instagram.com/ventfix.kg",
    },
    {
        iconWhite: "/img/tiktok.png",
        iconDark: "/img/tiktok.png",
        link: "https://www.tiktok.com/@ventfix.kg?_t=ZS-8srrWwaS8kT&_r=1",
    },
]